export const serviceTypes = [
  { id: "BILL", name: "قبض" },
  { id: "CHARGE", name: "شارژ" },
  { id: "SUBSCRIPTION", name: "اشتراک" },
];
